const aws_region = "us-east-1";

const config = {
  appName: "Trust UI - Non Prod",
  region: aws_region,
  cognito: {
    userPoolId: `${aws_region}_nW6D8ATAJ`,
    domain: `ispp-trust-co-token-nonprd.auth.${aws_region}.amazoncognito.com`,
    tokenUrl: `https://ispp-trust-co-token-nonprd.auth.${aws_region}.amazoncognito.com/oauth2/authorize`,
    providerId: "ispp-trust-co-identity-provider",
    redirectUrl: "https://citplanmanager.am.staging.principal.com",
    clientId: "3417td7susr4dtqolq0v78r2kb",
    scope: "ispp-trust-co-resource-server/read-write",
    readOnlyGroup: "trust-co-read-only-client",
    updateGroup: "ispp-trust-co-read-write-client",
  },
  api: {
    baseUrl: `https://kuoavwdvmf.execute-api.${aws_region}.amazonaws.com/prod/api`,
  },
};

export default config;
